module.exports = __webpack_public_path__ + "static/img/salepage-stk-promotion_07.1d9ac40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/promotion/salepage-stk-promotion_07.jpg
// module id = EeRl
// module chunks = 134